import { render } from "./DialogCouponSuccess.vue?vue&type=template&id=5376583d"
import script from "./DialogCouponSuccess.vue?vue&type=script&lang=js"
export * from "./DialogCouponSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script